import { attributes, define, Linked } from "@type-r/models";
import { useIO, useModel } from "@type-r/react";
import { PageContainer, PageTab, TransparentTabs, useLinkedLocation } from "lqx-react";
import * as React from "react";
import { CustomerProfileLandingPage, CustomerProfileLandingState } from "./customer-profile";
import { InvoicesLandingPage, InvoicesLandingState } from "./invoices";
import { PaymentsLandingPage, PaymentsLandingState } from "./payments-ras";

@define
export class LandingPageState extends attributes({
    invoicePage: InvoicesLandingState,
    paymentPage: PaymentsLandingState,
    customerProfilesPage: CustomerProfileLandingState
}) {
    async fetch() {
        await Promise.all([
            this.invoicePage.fetch(),
            this.paymentPage.fetch(),
            this.customerProfilesPage.fetch()
        ]);

        return this;
    }
}

export const LandingPage = () => {
    const $category = useLinkedLocation(2, "invoices");
    const state = useModel(LandingPageState);
    let isReady = useIO(async () => { await state.fetch() });

    return (
        <PageContainer
            header={
                <>
                    <h5>Review pending actions</h5>
                    <LandingPageHeader $category={$category} $state={state} />
                </>
            }
        >
            {
                $category.value === "orders" ? <h1>TBD</h1> :
                    $category.value === "invoices" ? <InvoicesLandingPage $state={state.invoicePage} /> :
                        $category.value === "payments" ? <PaymentsLandingPage $state={state.paymentPage}/> :
                            $category.value === "customer-profile" ? <CustomerProfileLandingPage $state={state.customerProfilesPage}/> :
                                <h1>Wrong path</h1>
            }
        </PageContainer>
    )
};

const LandingPageHeader = ({ $category, $state }: { $category: Linked<String>, $state: LandingPageState }) => {
    return (
        <TransparentTabs $value={$category}>
            {/* <PageTab
            value="orders"
            title="Orders"
            subtitle="pending actions"
            label={"666"}
        /> */}

            <PageTab
                value="invoices"
                title="Invoices"
                subtitle="pending actions"
                label={$state.invoicePage.isReady ? $state.invoicePage.getCount as any : 'loading'}
            />

            <PageTab
                value="payments"
                title="Payments & RAs"
                subtitle="pending actions"
                label={$state.paymentPage.isReady ?  $state.paymentPage.getCount as any : 'loading'}
            />

            <PageTab
                value="customer-profile"
                title="Customer Profile"
                subtitle="pending actions"
                label={$state.customerProfilesPage.isReady ?  $state.customerProfilesPage.getCount as any : 'loading'}
            />
        </TransparentTabs>
    )
}
